import Vue from "vue";
import App from "./App.vue";
import store from "@/flit2go-web-core/store/";
import router from "@/base/router";
import i18n from "@/flit2go-web-core/lang/";
import Constants from "@/flit2go-web-core/interfaces/index.js";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import _ from "lodash";
import VueCardFormat from "vue-credit-card-validation";
import * as Sentry from "@sentry/vue";
import { sentryScrubHooks } from "@/util/sentryScrub";

import "material-design-icons-iconfont/dist/material-design-icons.css";
import "@/flit2go-web-core/plugins/global-components";
import "./assets/tailwind.css";
import PageUtils from "@/flit2go-web-core/util/paginationUtil.js";
import VueTheMask from "vue-the-mask";
import VCalendar from "v-calendar";

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueTheMask);
Vue.use(VueCardFormat);
// Use v-calendar & v-date-picker components
Vue.use(VCalendar, {
  componentPrefix: "vc", // Use <vc-calendar /> instead of <v-calendar />
});

const SENTRY_ENVIRONMENTS = ["production", "qa"];

if (
  process.env.VUE_APP_SENTRY &&
  SENTRY_ENVIRONMENTS.includes(process.env.VUE_APP_MODE)
) {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY,
    environment: process.env.VUE_APP_MODE,
    release: `flit2go-frameweb@${process.env.PACKAGE_VERSION}`,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
    ],
    // Performance: 100% en qa para depurar, muestreo en producción.
    tracesSampleRate: process.env.VUE_APP_MODE === "production" ? 0.2 : 1.0,
    // Solo propagar cabeceras de trazas a nuestros backends
    tracePropagationTargets: ["localhost", /^https:\/\/[^/]*flit2go/, /^\//],
    // Errores de la app también se muestran en consola
    logErrors: true,
    // La apiKey del cliente viaja en la URL: se filtra de eventos, transacciones y breadcrumbs
    ...sentryScrubHooks,
  });
} else {
  console.log("Sentry not started environment: " + process.env.VUE_APP_MODE);
}

// Prototypes
Vue.prototype.$CONSTANTS = Constants;
Vue.prototype.$PageUtils = PageUtils;
Vue.prototype.$_ = _;

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
